import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import SlidersContainer from "./SliderComponent";
import BUDGET_API from "../../../../../apis/budget.api";
import moment from "moment";
import "./styles/budget.css";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import formatAmount from "../../../../../helpers/formatAmount";
import UseUpdateBugetHook from "./hook/updateBugetHook";
import { MODULE_API } from "../../../../../apis";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";

export default function Budget() {
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState({});
  const [formData, setFormData] = useState([]);
  const [fieldsformData, setFieldsFormData] = useState({});
  const [toUpdate, setToUpdate] = useState(false);
  const [fieldsData, setFieldsData] = useState({});
  const [fields, setFields] = useState({});

  const { updateBudget, updateLoading } = UseUpdateBugetHook();
  const getAllBudgets = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.clone().subtract(12, "months").startOf("month").format("YYYY-MM-DD");
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let data = await BUDGET_API.fetchAllBudget(startDate, endDate, "all");
      if (data && data.status === 200 && data.categorized) {
        // setBudgetData(data.categorized);
        const promises =
          data.categorized &&
          data.categorized.map((budget) => {
            const payload = {
              startDate,
              endDate,
              category: budget.categoryId, // Send categoryId for this budget
            };
            return BUDGET_API.getCalculatedBudgetTransactions(payload).then((response) => ({
              budget,
              response,
            }));
          });

        const results = await Promise.all(promises);

        const structuredData = results.map(({ budget, response }) => {
          console.log("Structured Data:", response);

          const usedAmount = response.currentMonthTransactions.totalAmount || 0;
          const totalAmount = budget.amount || 0;
          const totalDisabilityAmount = budget.disabilityBudget || 0;
          const newMonthlyBudget = totalDisabilityAmount ? totalDisabilityAmount-totalAmount : 0;
          const leftAmount = totalAmount - usedAmount;
          return {
            categoryId: budget && budget.categoryId && budget.categoryId,
            categoryName: (budget.budgetCategory && budget.budgetCategory.categoryName) || "",
            subCategoryId: (budget && budget.subCategoryId && budget.subCategoryId) || null,
            usedAmount,
            leftAmount,
            totalAmount,
            totalDisabilityAmount,
            newMonthlyBudget,
          };
        });
        console.log("Structured Data:", structuredData);
        const totalUsedAmount = structuredData.reduce((total, data) => {
          return total + data.usedAmount;
        }, 0)/ 12;
        const totalLeftAmount = structuredData.reduce((total, data) => {
          return total + data.leftAmount;
        }, 0);
        const totalAmount = structuredData.reduce((total, data) => {
          return total + data.totalAmount;
        }, 0);
        const totalNewBudget = structuredData.reduce((total, data) => {
          return total + data.newMonthlyBudget;
        }, 0)+totalUsedAmount;
        const totalDifference = totalUsedAmount - totalNewBudget;
        setTotalData({
          totalUsedAmount,
          totalLeftAmount,
          totalAmount,
          totalNewBudget,
          totalDifference
        });
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset("Disability Budget", {
        clientModules: [fieldsformData],
      });
      const res = await fetchData();
      console.log("resssssss", res);

      if (res && res.records) {
        setFieldsData(res.records);
      }
      console.log("result", result);
      setLoading(false);
      setToUpdate(true);
    } catch (error) {
      setLoading(false);
    }
  };
  const getAttributes = async (name) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(name);
      if (res && res.attributes) {
        setFields(res.attributes);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: "Disability Budget",
        pageNum: 1,
        limit: 10,
        body: {},
      });
      console.log("resssssss", res);
      if (res && res.records) {
        setFieldsData(res.records[0]);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(fieldsformData.id, {
        ...fieldsformData,
      });
      const res = await fetchData(fieldsformData.module);
      if (res && res.records) {
        setFields(res.records);
      }
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  console.log("formdata", formData);
  useEffect(() => {
    getAllBudgets();
    getAttributes("Disability Budget");
    fetchData();
  }, []);
  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);
  return (
    <>
      <div className="budget-container">
        <div className="budget-title-container">
          <h2 className="budget-title">Budget</h2>
        </div>
        <div className="budget-help-icon-container">
          <img src={helpIcon} alt="help" width="18.67px" height="18.67px" />
        </div>
      </div>
      <div className="input-fields-container" style={{position:"relative"}}>
        <DisabilityFormCreator data={fields} values={fieldsData} setSubmitBody={setFieldsFormData} />
        <NewLoader isLoading={loading} />
      </div>
      <div className="handle-submit-button-container">
        <button
          className="submit-button"
          onClick={() => {
            if (toUpdate) {
              updateRecord();
            } else {
              createAttributes();
            }
          }}
        >
          {toUpdate ? "Update" : "Submit"}
        </button>
      </div>
      <div className="categories-container">
        <div className="categories-title-container">
          <h2 className="categories-title">Categories</h2>
        </div>
        <div className="categories-help-icon-container">
          <img src={helpIcon} alt="help" width="18.67px" height="18.67px" />
        </div>
      </div>
      <div className="categories-description-container">
        <p className="categories-description">Adjust Your Average Monthly Budget </p>
      </div>
      <div className="slider-component-container">
        <SlidersContainer setFormData={setFormData} />
      </div>
      <div className="handle-submit-button-container">
        <button
          className="submit-button"
          onClick={async () => {
            await updateBudget(formData);
            await getAllBudgets();
          }}
        >
          Update Budget
        </button>
        <div className="summary-section-container">
          <div className="summary-section">
            <div className="total-summary-section">
              <h2 className="total-summary">Total</h2>
            </div>
            <div className="average-budget-summary-section">
              <h2 className="average-budget-summary">Average Budget</h2>
            </div>
          </div>
          <div className="amount-spend-section">
            <div className="amount-spend-title-section">
              <h2 className="spend-amount-title">Current Average Monthly Budget</h2>
            </div>
            <div className="spend-amount-amount-section">
              <h2 className="spend-amount-amount">
                ${totalData.totalUsedAmount ? formatAmount(totalData.totalUsedAmount) : 0.0}
              </h2>
            </div>
          </div>
          <div className="saved-amount-section">
            <div className="saved-amount-title-section">
              <h2 className="saved-amount-title">New Monthly Budget</h2>
            </div>
            <div className="saved-amount-amount-section">
              <h2 className="saved-amount-amount">
                ${totalData.totalNewBudget ? formatAmount(totalData.totalNewBudget) : 0.0}
              </h2>
            </div>
          </div>
          <div className="exceeded-amount-section">
            <div className="exceeded-amount-title-section">
              <h2 className="exceeded-amount-title">Monthly Difference</h2>
            </div>
            <div className="exceeded-amount-section">
              <h2 className="exceeded-amount-amount">
                ${totalData.totalDifference ? formatAmount(totalData.totalDifference) : 0.0}
              </h2>
            </div>
          </div>
          <NewLoader isLoading={updateLoading || loading} />
        </div>
      </div>
    </>
  );
}
